/*
 * @Description: 中文说明
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-15 14:14:19
 * @LastEditTime: 2019-07-24 14:36:08
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

//  普通仓库需求管理接口Url
const websiteDemandUrl = '/website/storage/demand'

//  查询成交列表接口Url
const findPageOrderSupplyUrl = '/website/storage/supply'

/* 获取地址接口 */
const getAreaUrl = `/sys/sysArea/find`

/* 查询字典接口 */
const getDictUrl = `/sys/dict/getDict`

// 获取字典接口
export function getDict(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getDictUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'getListByType',
        type: param,
        hasAll: 'no'
      }, {}))
    }
  })
}

// 批量发布
export function issueBatch(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + websiteDemandUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'issueBatch'
      }, param))
    }
  })
}

// 分页查询普通仓库需求列表
export function findPageDemand(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + websiteDemandUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findPageDemand'
      }, param))
    }
  })
}

// 修改数据普通仓库需求列表
export function demandEdit(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + websiteDemandUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'demandEdit'
      }, param))
    }
  })
}

// 获取地址接口
export function getArea(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getAreaUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findTreeData'
      }, param))
    }
  })
}

// 删除普通仓库需求列表
export function demandRemove(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + websiteDemandUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'demandRemove'
      }, param))
    }
  })
}

// 批量删除普通仓库需求列表
export function delBatch(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + websiteDemandUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'delBatch'
      }, param))
    }
  })
}

// 查询仓库需求详情信息
export function findDemandById(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + websiteDemandUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findDemandById'
      }, param))
    }
  })
}

// 查询仓库需求详情信息
export function findPageOrderSupply(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + findPageOrderSupplyUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findPageOrderSupply'
      }, param))
    }
  })
}

